import { useCoreClientQuery } from './client';

export const accountKeys = {
  base: ['currentAccount'] as const,
};

export const useActiveAccount = () => {
  return useCoreClientQuery({
    queryFn: (client) => (_queryContext) => client.Accounts.getCurrent(),
    queryKey: accountKeys.base,
    staleTime: Infinity,
  });
};
